const SOLANA_ADDRESS_PATTERN = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/;

function configuredMint(): string | null {
  const candidate = String(import.meta.env.VITE_INSERT_TOKEN_MINT || '').trim();
  return SOLANA_ADDRESS_PATTERN.test(candidate) ? candidate : null;
}

const mint = configuredMint();

/**
 * Source of truth for the new Trinity access-token launch.
 *
 * The mint deliberately stays null until an exact official address is
 * configured. This prevents the old DUBYA mint, a placeholder, or a lookalike
 * ticker from becoming an actionable acquisition link.
 */
export const INSERT_TOKEN = {
  name: 'Trinity AI',
  symbol: 'TRINITY',
  chain: 'Solana',
  pairAsset: 'USDC',
  mint,
  launchStatus: mint ? 'mint-configured' : 'launch-ready',
  launchUrl: 'https://dubya.ai/?launch=insert',
  referralUrl: 'https://dubya.ai/?launch=insert',
  sharedAnswerUrl:
    'https://dubya.ai/insert?utm_source=x&utm_medium=organic&utm_campaign=insert_shared_answer',
  referralAnswerUrl:
    'https://dubya.ai/?utm_source=direct&utm_medium=referral&utm_campaign=shared_answer',
  trinityUrl: 'https://dubya.ai/',
  vidyaDemoUrl:
    'https://dubya.ai/?view=vidya&demo=dubya-drop&utm_source=trinity&utm_medium=product&utm_campaign=trinity_access',
  challengeUrl:
    'https://dubya.ai/?launch=insert&demo=insert-drop&utm_source=direct&utm_medium=referral&utm_campaign=insert_challenge',
  pumpUrl: mint ? `https://pump.fun/coin/${mint}` : null,
  explorerUrl: mint ? `https://solscan.io/token/${mint}` : null,
  imageUrl: '/launch/trinity-token-mark-v2.png',
} as const;

export function buildInsertSharedAnswerIntent(): string {
  const text = [
    "I tried W AI, Dubya AI's free guest chat—no account or wallet required.",
    `$${INSERT_TOKEN.symbol} is the access token for the W AI decentralized-LLM ecosystem.`,
    `Explore the product and verify the exact official mint: ${INSERT_TOKEN.sharedAnswerUrl}`,
  ].join('\n\n');

  return `https://x.com/intent/post?text=${encodeURIComponent(text)}`;
}

export const INSERT_PRODUCTS = [
  {
    name: 'W AI',
    freeState: 'FREE GUEST CHAT LIVE',
    accessPlan: 'Access pass · about 10 days · $10 USD reference',
  },
] as const;

export function shortInsertMint(): string {
  if (!INSERT_TOKEN.mint) return 'VERIFY EXACT ADDRESS';
  return `${INSERT_TOKEN.mint.slice(0, 6)}…${INSERT_TOKEN.mint.slice(-6)}`;
}
